<template>
  <div class="full-m-num-body">
    <div class="full-m-num-item">
      <p>
        <span>总人数</span>
        <i>74<em>(人)</em></i>
      </p>
    </div>
    <div class="full-m-num-item">
      <p>
        <span>在寝人数</span>
        <i>60<em>(人)</em></i>
      </p>
    </div>
    <div class="full-m-num-item">
      <p>
        <span>离寝人数</span>
        <i>10<em>(人)</em></i>
      </p>
    </div>
    <div class="full-m-num-item">
      <p>
        <span>请假人数</span>
        <i>4<em>(人)</em></i>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.full-m-num-body {
  padding: 15px 0 0 15px;
  height: 170px;
  overflow: hidden;
  .full-m-num-item {
    width: 50%;
    float: left;
    padding-right: 15px;
    padding-bottom: 20px;
    p {
      background-color: rgba(15, 31, 56, 0.5);
      margin: 0;
      color: #fff;
      box-shadow: 0 0 5px #2c58a6;
      border-radius: 5px;
      span {
        font-size: 20px;
        display: block;
        text-align: center;
      }
      i {
        font-size: 20px;
        display: block;
        text-align: center;
        font-style: normal;
        em {
          font-style: normal;
          padding-left: 3px;
        }
      }
    }
  }
}
</style>
